import React from "react";
import { useUscOptionalLabel } from "../../../../../utils/labels";
import { useUscSelector } from "../../../../../redux/store";
import Text from "../../../../../../shared-components/lexus/styles/atoms/Text";

const BasketReclaimableVatDisclaimer = (): JSX.Element | null => {
    const reclaimableVAT = useUscSelector((state) => state.vehicle.result?.price?.reclaimableVAT);
    const disclaimerLabel = useUscOptionalLabel("uscBasketDisclaimerReclaimableVAT");

    if (!reclaimableVAT || !disclaimerLabel) return null;

    return (
        <Text tag="div" variant="paragraph-small-book" center>
            {disclaimerLabel}
        </Text>
    );
};

export default BasketReclaimableVatDisclaimer;
